import { Injectable } from '@angular/core';
import { EMPTY, Observable, of, mergeMap } from 'rxjs';
import { TicketApiService } from '../../../core/modules/tickets/ticket-api.service';

export interface TransactionTotalResult {
  SELL: TotalOperationResult;
  SELL_RETURN: TotalOperationResult;
  BUY: TotalOperationResult;
  BUY_RETURN: TotalOperationResult;
  cash: number;
  revenue: number;
}

interface TotalOperationResult {
  count?: number;
  operationType?: string;
  sum?: number;
}

@Injectable({
  providedIn: 'root',
})
export class ReportTransactionService {
  constructor(private ticketApiService: TicketApiService) {}

  // @ts-ignore
  getReportTotalResult(transactionId: string): Observable<TransactionTotalResult> {
    return this.ticketApiService.fetchReport(transactionId)
      .pipe(
        mergeMap((transactionDetail) => {
          if (!transactionDetail.zxReport.totalResult) {
            return EMPTY;
          }

          let cash = 0;
          transactionDetail.zxReport.ticketOperations
            // @ts-ignore
            .map((ticketOperation) => {
              // @ts-ignore
              const cashResult = ticketOperation.payments.find(payment => payment.paymentType === 'CASH');
              if (cashResult) {
                cash = cashResult.sum;
              }
            });

          const transactionTotalResult: TransactionTotalResult = {
            SELL: {},
            SELL_RETURN: {},
            BUY: {},
            BUY_RETURN: {},
            cash,
            revenue: transactionDetail.zxReport.revenue,
          };
          // @ts-ignore
          transactionDetail.zxReport.totalResult.forEach((result, index, array) => {
            // @ts-ignore
            transactionTotalResult[result.operationType] = array[index];
          });
          return of(transactionTotalResult);
        }),
      );
  }
}
